import { useMemo } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

type Result = {
	trackShareClick: () => void;
	trackJoinTeamClick: () => void;
	trackSignAdvocateClick: (isGuest: boolean) => void;
};

export function useCommunityPetitionLinkTracking(): Result {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();

	const track = useTracking();

	return useMemo(
		() => ({
			trackShareClick: () => {
				void track('community_petition_link_share_click', {
					petition_id: id,
				});
			},
			trackJoinTeamClick: () => {
				void track('community_petition_link_join_team_click', {
					petition_id: id,
				});
			},
			trackSignAdvocateClick: (isGuest: boolean) => {
				void track('community_petition_link_sign_advocate_click', {
					petition_id: id,
					recruit_context: isGuest ? 'guest' : 'non-guest',
				});
			},
		}),
		[track, id],
	);
}
